import React, { useEffect, useState } from "react";
import HeadImage from "../../assets/notAuthHeader.png";
import NotAuthWhyGolancer from "../../assets/notAuthWhyGolancer.mp4";
import SkillsImproving from "../../assets/register-head.png";
import TechIcons1 from "../../assets/tech-icons/1.png";
import TechIcons2 from "../../assets/tech-icons/2.png";
import TechIcons3 from "../../assets/tech-icons/3.png";
import TechIcons4 from "../../assets/tech-icons/4.png";
import TechIcons5 from "../../assets/tech-icons/5.png";
import TechIcons6 from "../../assets/tech-icons/6.png";
import TechIcons7 from "../../assets/tech-icons/7.png";
import TechIcons8 from "../../assets/tech-icons/8.png";
import WorkLife from "../../assets/WorkLife.png";
import LearnFolw from "../../assets/learn-flow.png";

import "./index.scss";
import { Button, Col, Row } from "antd";
import TrackCard from "../../components/track-card";
import {
  DollarOutlined,
  MoneyCollectOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { getAllTracks } from "../../store/apis/tracks";
import { useNavigate } from "react-router-dom";

function Home() {
  const tracksState = useSelector((state) => state?.tracks?.tracks);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAllTracks());
  }, []);

  const notAuthHead = () => {
    return (
      <div className="not-auth-head">
        <Row>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="head-image">
              <img src={HeadImage} />
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="head-description">
              <h2>كُن واثقاً من المستقبل </h2>
              <p>
                احصل على مهارات الغد ، وتعلم كيف تتعلم بكفاءة وتحكم في حياتك
                المهنية إلى الأبد. ابدء التطبيق و اكتشف البرامج التدريبية
              </p>
              <Button type="primary" onClick={() => navigate("/tracks")}>
                تعلم معنا الأن
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const whyGolancer = () => {
    return (
      <div className="why-golancer">
        <div className="learn-flow-card">
          <Row className="learn-flow-card-grid">
            <Col xs={24} sm={24} md={12} lg={6} xl={6}>
              <h2> هنا تبدأ رحلتك من العِلم إلى العَمل </h2>
            </Col>
            <Col xs={24} sm={24} md={12} lg={18} xl={18}>
              <img src={LearnFolw} />
            </Col>
          </Row>
        </div>
        <Row>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="why-golancer-image">
              <video
                width="90%"
                height="100%"
                autoPlay={true}
                // controls
                loop
                muted
              >
                <source
                  src={`https://golancer.tech/public/videos/1678891676048Golancer.mp4`}
                  type="video/mp4"
                />
              </video>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="why-golancer-description">
              <h2> لماذا قو لانسر ؟ </h2>
              <p>
                سواء كنت فردًا يتطلع إلى تعلم لغة فلاتر، لارافيل، الذكاء
                الاصطناعي، أو غيرها من المسارات التدريبية التكنولوجية المطلوبة
                في سوق العمل من أجل تعزيز حياتك المهنية أو منح فرقك المهارات
                اللازمة لتحصيل أفضل الوظائف، فان قو لانسر هي وجهتك الاولى لتحقيق
                ذلك، بالاضافة الى توفير تدريبات عملية من أجل الحصول على وظائف
                تقنية مرموقة عبر منصات العمل الحر، التواصل الاجتماعي، وفي شركات
                مميزة.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const MostPopularTracks = () => {
    console.log("tracksState", tracksState);
    return (
      <div className="most-popular-tracks">
        <div className="most-popular-tracks-description">
          <h2> المسارات الأكثر طلباً </h2>
          <p>
            اقتحام مجال جديد مثل تكنولوجيا المعلومات أو علم البيانات. لا توجد
            خبرة سابقة ضرورية للبدء.
          </p>
        </div>
        <Row className="tracks-cards-container">
          {tracksState &&
            tracksState?.docs?.map((item) => {
              return (
                <Col xs={24} sm={24} md={8} lg={6} xl={6} key={item._id}>
                  <a href={`/track/${item._id}`}>
                    <TrackCard track={item} />
                  </a>
                </Col>
              );
            })}
        </Row>
      </div>
    );
  };

  const skillsImproving = () => {
    return (
      <div className="skills-improving">
        <Row>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="skills-improving-image">
              <img src={SkillsImproving} />
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="skills-improving-description">
              <h2> إتقان المهارات اللازمة لقيادة حياتك المهنية </h2>
              <p>
                هل تتطلع إلى الحصول على شهادة في السحابة ، أو الارتقاء بمستوى في
                Linux ، أو تمهيد مسار وظيفي جديد مع Python؟ يمكن لمهارات
                التعددية أن تصل بك إلى هناك ، سواء كنت مبتدئًا للتو أو محترفًا
                متمرسًا
              </p>
              <div className="action-buttons">
                <Button type="primary" onClick={() => navigate("/tracks")}>
                  جربه الأن
                </Button>
                {/* <Button onClick={() => navigate("/tracks")}>شاهد المزيد</Button> */}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const moreTechUsed = () => {
    const data = [
      {
        total: "$ 120,726",
        description:
          "متوسط الراتب الأساسي لمهندس السحابة في الولايات المتحدة (بالإضافة إلى 10000 دولار مكافأة سنوية).",
        resource: " إنديد ، يونيو 2020",
        icno: <UsergroupAddOutlined />,
      },
      {
        total: " % 50 ",
        description:
          "هو عدد المنظمات التي تأثرت بالفعل بأزمة المهارات في جميع أنحاء العالم. قد يرتفع هذا الرقم إلى أكثر من 90٪ بحلول عام 2025.",
        resource: "لينكد إن",
        icno: <MoneyCollectOutlined />,
      },
      {
        total: "% 91",
        description:
          "عدد التقنيين الذين يهدفون إلى تحقيق الأهداف المهنية الشخصيةمن خلال تحسين مهاراتهم التقنية.",
        resource: "Global Knowledge، 2020",
        icno: <DollarOutlined />,
      },
    ];

    return (
      <div className="more-tech-used">
        <div className="more-tech-used-box">
          <h2> الأكثر شهرة للتعلم اليوم </h2>
          <div className="more-tech-used-icons">
            <div className="icon-box">
              <img src={TechIcons8} />
            </div>
            <div className="icon-box">
              <img src={TechIcons1} />
            </div>
            <div className="icon-box">
              <img src={TechIcons2} />
            </div>
            <div className="icon-box">
              <img src={TechIcons3} />
            </div>
            <div className="icon-box">
              <img src={TechIcons4} />
            </div>
            <div className="icon-box">
              <img src={TechIcons5} />
            </div>
            <div className="icon-box">
              <img src={TechIcons6} />
            </div>
            <div className="icon-box">
              <img src={TechIcons7} />
            </div>
          </div>
        </div>
        {/*  */}
        <Row justify="space-around">
          {data &&
            data?.map((item) => {
              return (
                <Col xs={24} sm={24} md={8} lg={6} xl={6}>
                  <div className="about-tech-card">
                    <div className="card-title">
                      {item.icno}
                      <h2> {item.total} </h2>
                    </div>
                    <div className="card-body">
                      <p>{item.description}</p>
                    </div>
                    <div className="card-footer">
                      <p> المصدر: {item.resource}</p>
                    </div>
                  </div>
                </Col>
              );
            })}
        </Row>
      </div>
    );
  };

  const workLife = () => {
    return (
      <div className="work-life">
        <Row>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="work-life-image">
              <img src={WorkLife} />
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div className="work-life-description">
              <h2> السيطرة على حياتك المهنية </h2>
              <p>
                بناء المهارات المطلوبة في كل شيء من الأمن السيبراني إلىتطوير
                البرمجيات. ثم استخدم هذه المهارات للارتقاء بحياتك المهنية -
                والأجر الذي تحصل عليه - إلى المستوى التالي بثقة.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <div className="not-auth-page-container">
      {notAuthHead()}
      {whyGolancer()}
      {MostPopularTracks()}
      {skillsImproving()}
      {moreTechUsed()}
      {workLife()}
    </div>
  );
}

export default Home;
